export default __webpack_public_path__ + "assets/687f13e9b521483ab24cbb91783dce77.jpg";